export default __webpack_public_path__ + "static/media/termlife_file_Icon.d3991204.svg";